"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listExtractionConfigsOutputDtoSchema = void 0;
const zod_1 = require("zod");
const hil_extraction_config_1 = require("../../types/hil-extraction-config");
exports.listExtractionConfigsOutputDtoSchema = zod_1.z.object({
    configs: hil_extraction_config_1.HilExtractionConfig.schema.array(),
});
//# sourceMappingURL=list-extraction-configs.dto.js.map